/* Чиповете на едната страница на семейство процедури.

   Всяка комбинация от избори е отделна услуга в базата. Тук няма сметки:
   щом се избере комбинация, викаме MILA_IZBERI_NIVO(услугата) и
   mila-rezervaciya.js показва нейната цена, време, капаро и часове.

   Данните идват от метаполето mila.izbori:
     {"redove":[{"klyuch":"zona","ime":"Зона","stoynosti":["ръце","гръб"]},
                {"klyuch":"sesii","ime":"Колко сеанса","stoynosti":["един","пакет 5"]}],
      "varianti":[{"zona":"ръце","sesii":"един","usluga":"<uuid>"}]}

   Комбинация, за която няма услуга, не се показва като избираема: инак
   жената избира „седалище · пакет 5", което не съществува, и получава
   празен календар. */
// На „Запази час" процедурата се сменя в движение, затова чиповете
// трябва да могат да се построят наново. Иначе жената избира микроблейдинг,
// вижда чиповете, после сменя на ламиниране и чиповете остават старите.
function милаСемейство(){
'use strict';

var кутия = document.getElementById('sem-izbori');
if(!кутия) return;

// Спираме чакащия часовник от предишното построяване.
if(window.__МИЛА_ЧАСОВНИК){ clearInterval(window.__МИЛА_ЧАСОВНИК); window.__МИЛА_ЧАСОВНИК = null; }

var Д;
try{ Д = JSON.parse(кутия.dataset.izbori || 'null'); }catch(e){ Д = null; }
if(!Д || !Д.redove || !Д.varianti){ кутия.hidden = true; return; }

// Антонио: „горе да е просто Христина / Грета, после зоната, отдолу един
// или 5 сеанса, и след това календара." Тоест градът НЕ е ред за избиране:
// той идва от човека, а под името му пише в кой салон работи.
var РЕД_ГРАД = 'grad';
Д.redove = Д.redove.filter(function(р){ return р.klyuch !== РЕД_ГРАД; });
var ИМА_ГРАД = Д.varianti.some(function(в){ return в[РЕД_ГРАД]; });

var ИЗБОР = {};

// НИЩО не е избрано в началото. Жената решава първо какво ѝ трябва, и
// чак тогава се появяват датите.
//
// Досега първата стойност стоеше избрана, а под нея вече имаше календар
// с избран ден. Два избора, направени вместо нея, преди да е видяла
// какво има. Антонио, 09.10.2026: „кой ден да е скрито, първо трябва да
// си избереш първичната. Като избереш първична, тогава ти излизат
// датите."
//
// Запазваме обаче вътрешния ред: щом избере, другите редове (ако има)
// тръгват от първата своя възможна стойност.
var ЗАПОЧНАЛО = false;

// Ако адресът носи ?nivo=, чиповете тръгват от НЕГО. Въпросникът вече е
// питал „правила ли си траен грим" и праща отговора насам. Без това
// чиповете се връщаха на „първична" и надвиваха избора, тоест жената,
// казала „да, тук при нас", виждаше цената на първичната. Видяно
// в браузъра на 08.10.2026.
try{
  var искано = new URLSearchParams(location.search).get('nivo');
  if(искано){
    var в = Д.varianti.filter(function(x){ return x.usluga === искано; })[0];
    if(в){
      Д.redove.forEach(function(р){
        if(в[р.klyuch] != null) ИЗБОР[р.klyuch] = в[р.klyuch];
      });
      // Изборът Е НАПРАВЕН — от адреса. Дотук само се оцветяваше чипът, а
      // `ЗАПОЧНАЛО` оставаше невярно: страницата продължаваше да смята, че
      // жената не е избрала нищо, скриваше списъка „При кого и кога" и
      // пишеше „Избери какво ти трябва отгоре".
      //
      // Жената от рекламата вижда оцветен чип, натиска го, и НИЩО не става:
      // натиснатото е вече избраното, тоест смяна няма. После си тръгва.
      // Намерено на 24.10.2026 по новите връзки към „Запази час".
      ЗАПОЧНАЛО = true;
      try{ document.body.classList.remove('sem-bez-izbor'); }catch(_){}
      // Другите редове тръгват от първата своя възможна стойност, точно
      // както при истинско натискане.
      Д.redove.forEach(function(р){
        if(ИЗБОР[р.klyuch]) return;
        var първа = р.stoynosti.filter(function(с){ return възможна(р.klyuch, с); })[0];
        ИЗБОР[р.klyuch] = първа || р.stoynosti[0];
      });
    }
  }

  // Без ?nivo= страницата започваше с нищо избрано и показваше
  // „Избери какво ти трябва отгоре". Жената вижда празен екран и трябва
  // сама да се досети, че чиповете са бутони.
  // Антонио, 29.10.2026: да е избрана първичната по подразбиране и да
  // излиза графикът. Натисне ли поддръжка, сменя се както досега.
  // Взима се първата ВЪЗМОЖНА стойност, не сляпо първата.
  if(!ЗАПОЧНАЛО && Д.redove && Д.redove.length){
    Д.redove.forEach(function(р){
      if(ИЗБОР[р.klyuch]) return;
      var първа = р.stoynosti.filter(function(с){ return възможна(р.klyuch, с); })[0];
      ИЗБОР[р.klyuch] = първа || р.stoynosti[0];
    });
    ЗАПОЧНАЛО = true;
    try{ document.body.classList.remove('sem-bez-izbor'); }catch(_){}
  }
}catch(e){}

// Възможна ли е стойността, при вече избраното по ДРУГИТЕ редове.
// Кой човек в кой салон работи. Пълни се от самата резервация, когато
// върне редовете: Грета е в София, Христина в Стара Загора. Не е зашито.
var ГРАД_НА_ЧОВЕК = {};

// Градът на избрания човек, ако го знаем. Докато не знаем, не ограничаваме:
// по-добре да се покаже нещо повече, отколкото да се скрие истинска зона.
// ПРОБЕН_ГРАД служи само на самопроверката: тя обикаля градовете, без да
// пипа кой е наистина избран.
var ПРОБЕН_ГРАД = null;
function градътСега(){
  if(ПРОБЕН_ГРАД) return ПРОБЕН_ГРАД;
  var кой = (typeof window.MILA_KOY_E_IZBRAN === 'function') ? window.MILA_KOY_E_IZBRAN() : null;
  return (кой && ГРАД_НА_ЧОВЕК[кой]) || null;
}

function възможна(ключ, стойност){
  var град = ИМА_ГРАД ? градътСега() : null;
  return Д.varianti.some(function(в){
    if(в[ключ] !== стойност) return false;
    // Зона, която избраният човек не прави, се зачерква, вместо човекът да
    // се сменя: Христина не прави „дете под 3 години". Антонио го поиска
    // точно така, за да не изчезва изборът ѝ под пръста.
    if(град && в[РЕД_ГРАД] && в[РЕД_ГРАД] !== град) return false;
    return Object.keys(ИЗБОР).every(function(к){
      return к === ключ || ИЗБОР[к] == null || в[к] === undefined || в[к] === ИЗБОР[к];
    });
  });
}

// Всички услуги, които отговарят на избраното: по една за всеки град.
// Те отиват в списъка „При кого", и човекът решава коя е активната.
function услугиЗаИзбора(){
  var сп = [];
  Д.varianti.filter(function(x){
    return Object.keys(ИЗБОР).every(function(к){ return x[к] === ИЗБОР[к]; });
  }).forEach(function(x){
    сп.push(x.usluga);
    // „sas" носи услугите, които ВЪРВЯТ СЪС същия избор: при първичната
    // това са ВИП нивата. Без него изборът ограничаваше до една услуга и
    // ВИП изчезваше от страницата заедно с „Не чакай дълго" — точно това
    // счупи микроблейдинга при първото обединяване на 08.10.2026.
    (x.sas || []).forEach(function(u){ if(сп.indexOf(u) < 0) сп.push(u); });
  });
  return сп;
}

function намериВариант(){
  return Д.varianti.filter(function(x){
    return Object.keys(ИЗБОР).every(function(к){
      return ИЗБОР[к] == null || x[к] === undefined || x[к] === ИЗБОР[к]; });
  })[0] || null;
}

function намериУслуга(){
  var в = намериВариант();
  return в ? в.usluga : null;
}

// Времето под цената. Резервацията го знае чак след като свали часовете,
// а чиповете го сменят веднага: пакетът за лице, шия и деколте е 90 минути,
// един сеанс за лице е 60. Числото идва от самия вариант.
// Времето следва АКТИВНАТА услуга, не първия подходящ вариант: едно ухо
// е 15 минути при Мила в София и 20 при Христина в Стара Загора.
function покажиВреме(){
  var е = document.getElementById('usl-traene');
  if(!е) return;
  var активна = (typeof window.MILA_AKTIVNA_USLUGA === 'function') ? window.MILA_AKTIVNA_USLUGA() : null;
  // Активната услуга се зачита само ако е сред избраните с чиповете.
  // Иначе на микроблейдинга пишеше „30 минути" при избрана първична,
  // защото резервацията беше спряла на поддръжката, която е 30.
  var мои = услугиЗаИзбора();
  if(активна && мои.indexOf(активна) < 0) активна = null;
  var в = (активна && Д.varianti.filter(function(x){ return x.usluga === активна; })[0]) || намериВариант();
  if(!в || !в.min) return;
  е.hidden = false;
  е.textContent = в.min + ' минути';
}

// Вика се от резервацията, щом човекът се смени. Зона, която избраният
// човек не прави, се зачерква в списъка, вместо човекът да се сменя.
window.MILA_SLED_SMYANA = function(){
  опресни();
  покажиВреме();
  // Цената и времето тръгват от самия вариант, веднага. Сървърът после
  // само потвърждава. Иначе горе стои цената на предишния избор.
  if(typeof window.MILA_ZADAI_CENA === 'function'){
    var вар = намериВариант();
    if(вар) window.MILA_ZADAI_CENA(вар.cena, вар.min);
  }
};

// Цената на една стойност, за да стои в падащото поле до името ѝ.
// Взима се от варианта, който излиза при вече избраното по другите редове.
// Цената в падащото поле е НА ИЗБРАНИЯ ЧОВЕК. Преди показваше софийската
// дори когато е избрана Христина: в полето „ръце · 92 €", а активната
// услуга беше нейната за 66. Жената виждаше едно число, плащаше друго.
function ценаНа(ключ, стойност){
  var град = ИМА_ГРАД ? градътСега() : null;
  var подходящи = Д.varianti.filter(function(x){
    if(x[ключ] !== стойност) return false;
    return Object.keys(ИЗБОР).every(function(к){
      return к === ключ || ИЗБОР[к] == null || x[к] === undefined || x[к] === ИЗБОР[к];
    });
  });
  var в = (град && подходящи.filter(function(x){ return x[РЕД_ГРАД] === град; })[0]) || подходящи[0];
  return (в && в.cena) ? в.cena : null;
}

// Много стойности се събират в едно поле, малко остават чипове.
//
// Антонио: „не 8 чипа на 2 реда, а СЪБРАНО: едно поле, натискаш и избираш
// от списък." Нативен <select> нарочно: на iPhone отваря колелото, с което
// жената вече знае да работи, и не заема място, докато е затворено.
// При две или три стойности едно поле е по-тромаво от два бутона, затова
// там остават чипове.
var СЪБИРАЙ_ОТ = 4;

// Свито на един ред, както е при „При кого и кога". Антонио, 08.10.2026:
// „Какво ти трябва да се скрива настрани, а отдолу да бъде календарът,
// защото в момента календарът изглежда много гадно."
//
// На телефон три дълги чипа заемаха цял екран и буташеха дните надолу.
// Сега стои един ред с избраното и се отваря само ако жената иска друго.

function подредба(стойности){
  var най = 0;
  стойности.forEach(function(с){ най = Math.max(най, String(с).length); });
  if(стойности.length > 6) return ' sem-mnogo';      // зоните на лазера
  if(най <= 14) return ' sem-kratki';                // вежди · мигли · да · не
  if(най <= 26) return ' sem-dve';                   // маникюрът
  return ' sem-edno';                                // микроблейдингът
}

function нарисувай(){
  кутия.innerHTML = Д.redove.map(function(р){
    var глава = '<span class="sem-etiket">' + р.ime + '</span>';

    // Най-търсените стоят открито, останалите чакат зад бутон. Точно
    // както е при лазерната епилация. Антонио, 09.10.2026: „най-търсените
    // отгоре, които си добавиш, избираш, готово — после ден и часове."
    //
    // Пада ли се на падащо меню, жената чете десет реда, преди да разбере
    // кое иска. С чипове вижда шестте, които всички избират, и натиска.
    if(р.nay_targeni && р.nay_targeni.length){
      var горе = р.nay_targeni.filter(function(с){ return р.stoynosti.indexOf(с) >= 0; });
      var долу = р.stoynosti.filter(function(с){ return горе.indexOf(с) < 0; });
      var чип = function(с){
        return '<button type="button" class="sem-chip"' +
          ' data-red="' + р.klyuch + '"' +
          ' data-stoynost="' + String(с).replace(/"/g,'&quot;') + '">' + с + '</button>';
      };
      return '<div class="sem-red" data-red="' + р.klyuch + '">' + глава +
        '<div class="sem-chipove">' + горе.map(чип).join('') + '</div>' +
        (долу.length
          ? '<button type="button" class="sem-oshte-butn" data-red="' + р.klyuch + '">' +
              'Виж всички · още ' + долу.length + '</button>' +
            '<div class="sem-chipove sem-oshte" hidden>' + долу.map(чип).join('') + '</div>'
          : '') +
        '</div>';
    }

    if(р.stoynosti.length >= СЪБИРАЙ_ОТ){
      // Празен първи ред, докато жената не избере.
      //
      // Браузърът сам показва първата стойност като избрана, а системата
      // още не брои нищо избрано — тоест на екрана пише „1-ва", а
      // календарът не идва. Жената трябваше да смени на друго и да се
      // върне, за да се задейства. Видяно на премахването на стар грим,
      // 09.10.2026.
      var опции = (ЗАПОЧНАЛО ? '' : '<option value="">избери</option>') +
        р.stoynosti.map(function(с){
          return '<option value="' + String(с).replace(/"/g,'&quot;') + '">' + с + '</option>';
        }).join('');
      return '<div class="sem-red" data-red="' + р.klyuch + '">' + глава +
        '<select class="sem-pole" data-red="' + р.klyuch + '">' + опции + '</select></div>';
    }

    return '<div class="sem-red" data-red="' + р.klyuch + '">' + глава +
      '<div class="sem-chipove' + подредба(р.stoynosti) + '">' + р.stoynosti.map(function(с){
        return '<button type="button" class="sem-chip"' +
          ' data-red="' + р.klyuch + '"' +
          ' data-stoynost="' + String(с).replace(/"/g,'&quot;') + '">' + с + '</button>';
      }).join('') + '</div></div>';
  }).join('');

  // Трите стоят открито, докато жената избере. После се свиват в един ред
  // с „смени", както правят денят и часът отдолу. Антонио, 08.10.2026:
  // „като избера Мила и после първичната, искам тази първичност да се
  // скрие, за да ми се качи нагоре кой ден."
  //
  // Свитият ред се прави веднъж и се пази между опресняванията: иначе
  // всяко прерисуване го триеше заедно с чиповете.
  if(!кутия.querySelector('.sem-svit-red')){
    var ред = document.createElement('button');
    ред.type = 'button';
    ред.className = 'rez-red-svit sem-svit-red';
    ред.hidden = true;
    ред.addEventListener('click', function(){ свитоЛи = false; подредиМе(); });
    кутия.insertBefore(ред, кутия.firstChild);
  }
  опресни();
  подредиМе();
}

// Избрано ли е вече. Тръгва отворено: жената още не е решила.
var свитоЛи = false;

function всичкиИзбрани(){
  return Д.redove.every(function(р){ return !!ИЗБОР[р.klyuch]; });
}

function подредиМе(){
  var ред = кутия.querySelector('.sem-svit-red');
  if(!ред) return;
  var текст = Д.redove.map(function(р){ return ИЗБОР[р.klyuch] || ''; })
                .filter(Boolean).join(' · ');
  [].forEach.call(кутия.querySelectorAll('.sem-red'), function(е){
    // Ред, който не важи за този избор, остава скрит и когато не е свито.
    е.hidden = свитоЛи || е.dataset.nevazhi === '1';
  });
  if(свитоЛи && текст) {
    ред.hidden = false;
    ред.innerHTML = '<b>' + текст + '</b><i>смени</i>';
  } else {
    ред.hidden = true;
  }
}

// Опресняване НА МЯСТО, без да се пренаписва разметката.
//
// Преди всяка промяна правеше кутия.innerHTML = …, тоест унищожаваше точно
// полето, с което човекът работи в момента. На телефон това остави избора
// на първата зона без ефект: събитието идва от елемент, който вече не е в
// страницата, и стойността се чете празна.
//
// Затова сега полетата се правят ВЕДНЪЖ, а после само се мени кое е
// избрано и кое е недостъпно. Избраното се задава със СВОЙСТВОТО selected,
// не с атрибута: атрибутът остава от разметката и подвежда.
function опресни(){
  Д.redove.forEach(function(р){
    var поле = кутия.querySelector('select.sem-pole[data-red="' + р.klyuch + '"]');
    if(поле){
      [].forEach.call(поле.options, function(о){
        var с = о.value;
        // Празният ред е подканата „избери", не стойност: не му слагаме
        // цена и не го наричаме „(няма)".
        if(с === ''){ о.textContent = 'избери'; о.disabled = false; о.selected = !ИЗБОР[р.klyuch]; return; }
        var мога = възможна(р.klyuch, с);
        var ц = ценаНа(р.klyuch, с);
        о.disabled = !мога;
        о.textContent = с + (ц ? ' \u00b7 ' + Math.round(ц) + ' \u20ac' : '') + (мога ? '' : ' (няма)');
        о.selected = (ИЗБОР[р.klyuch] === с);
      });
      if(поле.value !== (ИЗБОР[р.klyuch] || '')) поле.value = ИЗБОР[р.klyuch] || '';
      return;
    }
    [].forEach.call(кутия.querySelectorAll('.sem-chip[data-red="' + р.klyuch + '"]'), function(б){
      var с = б.dataset.stoynost;
      var мога = възможна(р.klyuch, с);
      б.disabled = !мога;
      б.classList.toggle('nyama', !мога);
      б.classList.toggle('on', ИЗБОР[р.klyuch] === с);
      if(мога) б.removeAttribute('aria-disabled'); else б.setAttribute('aria-disabled','true');
    });

    // Цял ред, който не важи за този избор, се скрива — не се зачерква.
    //
    // „Дължина на ноктите" няма смисъл при педикюр, „Педикюрът" няма
    // смисъл при самостоятелен маникюр. Зачеркнат ред заема място и
    // кара жената да мисли, че е пропуснала нещо.
    // Антонио, 10.10.2026: „да го направим както на ламинирането, да
    // няма такъв дълъг списък надолу."
    var имаНещо = р.stoynosti.some(function(с){ return възможна(р.klyuch, с); });
    var кутияРед = кутия.querySelector('.sem-red[data-red="' + р.klyuch + '"]');
    if(кутияРед){
      кутияРед.dataset.nevazhi = имаНещо ? '' : '1';
      кутияРед.hidden = свитоЛи || !имаНещо;
    }
    // Избраното в скрит ред се забравя, инак то продължава да стеснява
    // останалите редове невидимо.
    if(!имаНещо && ИЗБОР[р.klyuch] != null) ИЗБОР[р.klyuch] = null;
  });
}

// Връща true само когато резервацията наистина е приела услугата: тя
// познава услугите чак след като свали часовете.
function приложи(){
  // Докато жената не е избрала, НЕ налагаме услуга: инак резервацията
  // пак сама решава коя е и календарът тръгва да се пълни.
  if(!ЗАПОЧНАЛО) return true;
  var списък = услугиЗаИзбора();
  if(!списък.length) return false;

  // Какво точно е избрала жената, с думи. Ади: „важно е да са с номера,
  // защото ние следим кой клиент колко лазера си е правил". Самата услуга
  // отдолу е една и съща за втори и за пети сеанс, затова номерът стига до
  // картона само оттук.
  try{
    window.MILA_IZBOR_TEKST = (Д.redove || []).map(function(р){
      return р.ime + ': ' + (ИЗБОР[р.klyuch] || '');
    }).filter(function(т){ return т.slice(-2) !== ': '; }).join(' \u00B7 ') || null;
  }catch(e){ window.MILA_IZBOR_TEKST = null; }

  if(typeof window.MILA_OGRANICHI === 'function'){
    var останали = window.MILA_OGRANICHI(списък);
    if(останали) останали.forEach(function(r){ if(r.staff && r.grad) ГРАД_НА_ЧОВЕК[r.staff] = r.grad; });
    return !!(останали && останали.length);
  }
  // Резервна пътека: ако ограничаването още го няма, избираме едната услуга.
  if(typeof window.MILA_IZBERI_NIVO === 'function') return window.MILA_IZBERI_NIVO(списък[0]) === true;
  return false;
}

// Когато превключването не стане, старата услуга НЕ бива да остава
// активна: точно това накара пробиването в Стара Загора да показва
// софийската цена и софийски часове. Жената щеше да плати 71 € за нещо,
// което струва 61, и да отиде в другия град.
// Съобщението при неуспех НЕ пренаписва календара.
//
// Преди тук стоеше rez.innerHTML = …, което изтриваше rez-dni и
// rez-chasove от страницата. Оттам нататък всяко следващо превключване
// падаше, защото календарът го нямаше: един неуспех вкарваше страницата
// в задънена улица до презареждане. Затова сега календарът само се скрива,
// а съобщението е отделен възел до него.
function възелЗаСъобщение(){
  var р = document.getElementById('rez');
  if(!р) return null;
  var е = document.getElementById('sem-nyama');
  if(!е){
    е = document.createElement('p');
    е.id = 'sem-nyama';
    е.className = 'usl-chaka usl-telefon';
    е.hidden = true;
    р.parentNode.insertBefore(е, р);
  }
  return е;
}

function скрийСъобщението(){
  покажиЧеЧакаме.от = null;
  var е = document.getElementById('sem-nyama');
  if(е) е.hidden = true;
  var р = document.getElementById('rez');
  if(р) р.hidden = false;
  var л = document.querySelector('.usl-lenta');
  if(л) л.hidden = false;
}

// Докато жената не избере, долната част не бива да стои полуготова.
//
// На премахването горе пишеше „избери", а отдолу вече стоеше Мила
// Савова с цена и дата — две неща, които си противоречат. Жената не
// разбира, че има още стъпка, натиска „Запази час" и нищо не става.
// Антонио, 09.10.2026: „покажи на хората, че трябва да си изберат."
function подканиЗаИзбор(){
  // На страницата „Запази час" чиповете стоят скрити, докато жената не
  // избере процедура от списъка. Подканата нямаше къде да се покаже, а
  // скриването на #rez оставяше цялата страница бяла: заглавие, групи и
  // календар изчезваха наведнъж. Антонио го видя на 22.10.2026.
  //
  // Правилото е просто: подканваме само когато има какво да се натисне.
  if(кутия.hidden) return;
  var р = document.getElementById('rez');
  var х = document.getElementById('usl-hora');
  var л = document.querySelector('.usl-lenta');
  // На продуктовата страница чиповете стоят ИЗВЪН #rez, затова скриването
  // му оставя избора видим. На „Запази час" те са ВЪТРЕ в него: скриеш ли
  // секцията, скриваш и самите чипове, и човекът остава пред празно,
  // без какво да натисне. Затова тук не пипаме секцията, а само подканваме.
  var чиповетеСаВътре = р && р.contains(кутия);
  if(р && !чиповетеСаВътре) р.hidden = true;
  if(х) х.hidden = true;
  if(л) л.hidden = true;
  var е = document.getElementById('sem-podkana');
  if(!е){
    е = document.createElement('div');
    е.id = 'sem-podkana';
    е.className = 'sem-podkana';
    кутия.parentNode.insertBefore(е, кутия.nextSibling);
  }
  var р0 = Д.redove[0];
  е.textContent = 'Избери ' + String((р0 && р0.ime) || 'какво искаш').toLowerCase() +
                  ' отгоре, за да видиш свободните часове.';
  е.hidden = false;
  кутия.classList.add('sem-chaka-izbor');
}
function махниПодканата(){
  var е = document.getElementById('sem-podkana');
  if(е) е.hidden = true;
  var х = document.getElementById('usl-hora');
  if(х) х.hidden = false;
  кутия.classList.remove('sem-chaka-izbor');
}

window.MILA_SLED_ZAREZHDANE = function(){
  if(!ЗАПОЧНАЛО) return;
  var ок = false;
  try{ ок = приложи(); }catch(e){ ок = false; }
  if(ок){
    скрийСъобщението();
    var р = document.getElementById('rez'); if(р) р.hidden = false;
    var л = document.querySelector('.usl-lenta'); if(л) л.hidden = false;
  } else {
    кажиЧеНеСтава(намериВариант());
  }
};

function покажиЧеЧакаме(){
  var е = възелЗаСъобщение();
  if(!е) return;
  е.hidden = false;
  е.innerHTML = 'Свалям свободните часове\u2026';
  var р = document.getElementById('rez');
  if(р) р.hidden = true;
  // Пробваме отново, щом часовете пристигнат.
  clearTimeout(покажиЧеЧакаме.т);
  // Чакането си има край: 12 секунди. Инак при истинска липса на часове
  // жената гледа „Свалям…" до безкрай.
  if(покажиЧеЧакаме.от == null) покажиЧеЧакаме.от = Date.now();
  покажиЧеЧакаме.т = setTimeout(function(){
    var ощеМоже = (Date.now() - покажиЧеЧакаме.от) < 12000;
    if(ощеМоже && ((typeof window.MILA_ZAREZHDA === 'function' && window.MILA_ZAREZHDA()) ||
        (function(){ try{ var ц=услугиЗаИзбора()[0];
          return !!(ц && typeof window.MILA_ZNAE_USLUGA==='function' && !window.MILA_ZNAE_USLUGA(ц)); }
          catch(e){ return false; } })()))
      return покажиЧеЧакаме();
    покажиЧеЧакаме.от = null;
    var ок = false;
    try{ ок = приложи(); }catch(e){}
    if(ок){ скрийСъобщението(); var р2=document.getElementById('rez'); if(р2) р2.hidden=false; }
    else кажиЧеНеСтава(намериВариант());
  }, 500);
}

function кажиЧеНеСтава(вариант){
  var е = възелЗаСъобщение();
  if(!е) return;
  var тел = (вариант && /Стара/.test(вариант.grad || '')) ? '0889 926 005' : '0885 041 696';
  е.hidden = false;
  е.innerHTML = 'Този избор не се запазва онлайн. Обади се и ще уговорим час.' +
    '<a class="mila-btn pln" href="tel:+359' + тел.replace(/\s/g,'').replace(/^0/,'') + '">' + тел + '</a>';
  var р = document.getElementById('rez');
  if(р) р.hidden = true;
  var л = document.querySelector('.usl-lenta');
  if(л) л.hidden = true;
}

function смени(ред, ст){
  // Стойност, която не е в този ред, се пропуска: ако елементът вече е
  // извън страницата, браузърът връща празно, а празното чупеше всичко
  // отдолу, защото нито един вариант не му отговаря.
  var р = Д.redove.filter(function(x){ return x.klyuch === ред; })[0];
  if(!р || р.stoynosti.indexOf(ст) < 0) return;
  // Стойност, която в момента не е възможна, се отказва. Правилото на
  // Антонио е зоната да се зачерква, а човекът да остава, затова приемането
  // ѝ щеше да смени човека, точно обратното на исканото. В страницата тя
  // вече е недостъпна, така че това важи само ако дойде отвън.
  if(!възможна(ред, ст)){ опресни(); return; }
  if(ИЗБОР[ред] === ст){ подредиМе(); опресни(); return; }
  ИЗБОР[ред] = ст;
  // Редовете НЕ се свиват. Антонио, 09.10.2026: „искам да останат както
  // са" — жената вижда какво е избрала и сменя с едно натискане, вместо
  // да отваря свит ред.
  свитоЛи = false;
  if(!ЗАПОЧНАЛО){
    ЗАПОЧНАЛО = true;
    document.body.classList.remove('sem-bez-izbor');
    // другите редове тръгват от първата своя възможна стойност
    Д.redove.forEach(function(р){
      if(ИЗБОР[р.klyuch]) return;
      var първа = р.stoynosti.filter(function(с){ return възможна(р.klyuch, с); })[0];
      ИЗБОР[р.klyuch] = първа || р.stoynosti[0];
    });
  }

  // Смяната на един ред може да направи избраното по друг ред невъзможно:
  // „седалище" няма пакет. Тогава другият ред се връща на първата своя
  // възможна стойност, вместо да остане на нещо, което не съществува.
  Д.redove.forEach(function(р){
    if(р.klyuch === ред) return;
    if(!възможна(р.klyuch, ИЗБОР[р.klyuch])){
      var нова = р.stoynosti.filter(function(с){ return възможна(р.klyuch, с); })[0];
      if(нова) ИЗБОР[р.klyuch] = нова;
    }
  });
  опресни();
  покажиВреме();
  // Цената тръгва от самия чип, веднага. Вариантът я носи в страницата
  // от самото начало; сървърът после само потвърждава.
  //
  // Първия път сложих този ред в MILA_SLED_SMYANA — функцията, която се
  // вика при смяна на ЧОВЕКА, не на чипа. Затова на маникюра горе стоеше
  // €15 при всеки избор. 12.10.2026.
  if(typeof window.MILA_ZADAI_CENA === 'function'){
    var вар0 = намериВариант();
    if(вар0 && вар0.cena) window.MILA_ZADAI_CENA(вар0.cena, вар0.min);
  }
  // Изборът може да иска снимка и уговорка вместо час.
  if(typeof window.MILA_OPRESNI_TRIAZH === 'function'){
    try{ window.MILA_OPRESNI_TRIAZH(); }catch(e){}
  }
  // Ако нещо вътре в резервацията гръмне, чиповете трябва да продължат да
  // работят: иначе една грешка заключва цялата страница.
  var стана = false;
  try{ стана = приложи(); }
  catch(e){ стана = false; if(window.console) console.error('[mila] превключването гръмна:', e); }
  if(!ЗАПОЧНАЛО){ подканиЗаИзбор(); подредиМе(); return; }
  махниПодканата();
  // Не стана ли, първо питаме ЗАЩО. Ако резервацията още не знае за тази
  // услуга, тя просто не е стигнала дотам: това е чакане, не отказ.
  // Иначе страницата умираше в „този избор не се запазва онлайн" и не
  // се съвземаше. Антонио/рекламният чат, 27.10.2026, устните.
  var ощеНеЗнае = false;
  try{
    var ц = услугиЗаИзбора()[0];
    ощеНеЗнае = !!(ц && typeof window.MILA_ZNAE_USLUGA === 'function' &&
                   !window.MILA_ZNAE_USLUGA(ц));
  }catch(e){}
  if(стана) скрийСъобщението();
  else if(ощеНеЗнае || (typeof window.MILA_ZAREZHDA === 'function' && window.MILA_ZAREZHDA())){
    // Часовете още пътуват. „Обади се" тук е лъжа: само изглежда, че няма
    // свободно, защото още не сме попитали докрай. Казваме, че чакаме, и
    // се пробваме пак, щом свалянето приключи.
    покажиЧеЧакаме();
  }
  else кажиЧеНеСтава(намериВариант());
  подредиМе();
}

kутияДопълнителни();
function kутияДопълнителни(){
  кутия.addEventListener('click', function(е){
    var б = е.target.closest('.sem-oshte-butn');
    if(!б) return;
    var сп = б.parentNode.querySelector('.sem-oshte');
    if(!сп) return;
    сп.hidden = !сп.hidden;
    б.textContent = сп.hidden
      ? ('Виж всички · още ' + сп.querySelectorAll('.sem-chip').length)
      : 'Скрий останалите';
  });
}

кутия.addEventListener('click', function(е){
  var б = е.target.closest('.sem-chip');
  if(!б || б.disabled) return;
  // Страницата още превключва на поисканата процедура (`?usluga=` или
  // `?nivo=`): натискането изчаква. Виж бележката в mila-zapazi.liquid.
  //
  // Пазачът стои ТУК, не вътре в `смени()`. Сложих го първо там и спрях
  // и автоматичния избор, който самата страница прави при `?nivo=` —
  // тогава тя оставаше на микроблейдинга, чиповете искаха устни и
  // излизаше „Този избор не се запазва онлайн". Антонио го видя на
  // 27.10.2026. Човек натиска, машината не натиска.
  if(document.body.classList.contains('sem-chaka-smyana')) return;
  смени(б.dataset.red, б.dataset.stoynost);
});

// И двете събития: на iOS нативният избор праща change, а автоматиката и
// някои браузъри пращат input. Двойното викане е безвредно, защото смени()
// излиза веднага, ако стойността е същата.
['change','input'].forEach(function(вид){
  кутия.addEventListener(вид, function(е){
    var п = е.target && е.target.closest ? е.target.closest('.sem-pole') : null;
    if(!п) return;
    // Стойността се чете САМО от самото поле, не от атрибута selected в
    // разметката: той си остава на първата опция и подвежда.
    var ст = п.value;
    if(ст === '' && п.selectedIndex >= 0 && п.options[п.selectedIndex]) ст = п.options[п.selectedIndex].value;
    смени(п.dataset.red, ст);
  });
});

// Самопроверка: за всяка двойка човек по избор минава ли се до услуга.
// Пуска се веднъж, щом часовете се свалят, и пише САМО ако нещо не върви.
// Целта е следващият път да не се налага да се гадае по екранна снимка.
function самопроверка(){
  if(!window.console || !Д || !Д.varianti) return;
  var пазиИзбор = JSON.parse(JSON.stringify(ИЗБОР));
  var градове = ИМА_ГРАД
    ? Object.keys(Д.varianti.reduce(function(a,в){ if(в[РЕД_ГРАД]) a[в[РЕД_ГРАД]]=1; return a; }, {}))
    : [null];
  var лоши = [];
  градове.forEach(function(град){
    var пазиГрад = ПРОБЕН_ГРАД; ПРОБЕН_ГРАД = град;
    Д.varianti.forEach(function(в){
      if(град && в[РЕД_ГРАД] && в[РЕД_ГРАД] !== град) return;
      Д.redove.forEach(function(р){ ИЗБОР[р.klyuch] = в[р.klyuch]; });
      var мога = Д.redove.every(function(р){ return възможна(р.klyuch, ИЗБОР[р.klyuch]); });
      var у = услугиЗаИзбора();
      if(!мога || !у.length){
        лоши.push((град || 'без град') + ' · ' +
          Д.redove.map(function(р){ return в[р.klyuch]; }).join(' · ') +
          ' → възможна:' + мога + ' услуги:' + у.length);
      }
    });
    ПРОБЕН_ГРАД = пазиГрад;
  });
  ИЗБОР = пазиИзбор;
  if(лоши.length){
    console.warn('[mila] непроходими комбинации: ' + лоши.length);
    лоши.forEach(function(т){ console.warn('   ' + т); });
  } else {
    console.info('[mila] самопроверка: всички ' + Д.varianti.length + ' комбинации стигат до услуга.');
  }
}

нарисувай();
покажиВреме();
самопроверка();
if(!ЗАПОЧНАЛО) подканиЗаИзбор();

// Резервацията се зарежда след това: чакаме я, преди да ѝ кажем кое е
// избрано. Проверява се на кратки отрязъци, най-много три секунди.
var опити = 0;
var часовник = setInterval(function(){
  опити++;
  if(приложи() || опити > 60) clearInterval(часовник);
}, 150);
window.__МИЛА_ЧАСОВНИК = часовник;
}

document.body.classList.add('sem-bez-izbor');
милаСемейство();
window.MILA_SEMEYSTVO_NANOVO = милаСемейство;
